export default "__VITE_ASSET__a5b08eb1__"